import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;

export const LOGIN_URL = APIURL+"/login";
export const REGISTER_URL = APIURL+"/register";
export const REQUEST_PASSWORD_URL = APIURL+"/forgot-password";

export const ME_URL = APIURL+"/me";

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.post(ME_URL);
}
